// AWS CloudWatch RUM was stripped when the homepage folded into apps/web: the
// ECS runtime gate rejects aws-rum-web on the production dependency graph, and
// the host owns a single Datadog Browser RUM (shared/observability). These
// hooks stay as no-ops so every existing `if (awsRum)` call site keeps its
// shape (and records nothing) without a behavioral edit to surface code.

/** The subset of the AWS RUM client the surface's call sites use. */
export interface AwsRumClient {
    recordEvent: (name: string, attributes: Record<string, unknown>) => void;
    recordError: (error: unknown) => void;
}

export interface AWSRumProps {
    applicationIds: Record<string, string>;
    identityPoolId?: string;
    rumGuestRoleArn?: string;
}

export const useInitAwsRum = (_props: AWSRumProps): AwsRumClient | null => null;

export const useAwsRum = (): AwsRumClient | null => null;
